"use strict";

const hours = {
  lun: { start: 7 * 60, end: 26 * 60 },
  mar: { start: 7 * 60, end: 26 * 60 },
  mer: { start: 7 * 60, end: 26 * 60 },
  jeu: { start: 7 * 60, end: 26 * 60 },
  ven: { start: 8 * 60, end: 28 * 60 },
  sam: { start: 8 * 60, end: 28 * 60 },
  dim: { start: 8 * 60, end: 24 * 60 },
};

const getHeader = document.querySelector("header");

const statusDiv = document.querySelector(".status");

const statusImage = document.querySelector("#statusImg");
const statusText = statusDiv.querySelector("p");

function getOpeningHours() {
  const now = new Date();
  const day = now.getDay();

  switch (day) {
    case 0:
      return hours["dim"];
    case 1:
      return hours["lun"];
    case 2:
      return hours["mar"];
    case 3:
      return hours["mer"];
    case 4:
      return hours["jeu"];
    case 5:
      return hours["ven"];
    case 6:
      return hours["sam"];
    default:
      return hours["lun"];
  }
}

function isOpen() {
  const now = new Date();
  const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
  const openingHours = getOpeningHours();

  if (!openingHours) return false;

  const start = openingHours.start;
  const end = openingHours.end;

  if (end > 24 * 60) {
    return (
      currentTimeInMinutes >= start || currentTimeInMinutes < end - 24 * 60
    );
  } else {
    return currentTimeInMinutes >= start && currentTimeInMinutes < end;
  }
}

function updateSchedule() {
  if (!statusImage || !statusText) {
    console.error("Image or text element not found");
    return;
  }

  const hoursInfo = getOpeningHours();
  const start = Math.floor(hoursInfo.start / 60);
  const end = Math.floor((hoursInfo.end % (24 * 60)) / 60);
  const startFormatted = `${start.toString().padStart(2, "0")}:00`;
  const endFormatted = `${end.toString().padStart(2, "0")}:00`;

  statusText.innerHTML = `${startFormatted} - ${endFormatted}`;

  if (isOpen()) {
    statusImage.src =
      "https://cdn.shopify.com/s/files/1/0839/6826/2477/files/open-icon.svg?v=1736113007";
  } else {
    statusImage.src =
      "https://cdn.shopify.com/s/files/1/0839/6826/2477/files/closed-icon.svg?v=1736113007";
  }
}

updateSchedule();

setInterval(updateSchedule, 60000);
